import './App.css'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'

import gallery1 from './images/gallery1.jpg'
import gallery2 from './images/gallery2.jpg'
import gallery3 from './images/gallery3.jpg'
import gallery4 from './images/gallery4.jpg'
import gallery5 from './images/gallery5.jpg'
import gallery6 from './images/gallery6.jpg'
import gallery7 from './images/gallery7.jpg'
import gallery8 from './images/gallery8.jpg'
import gallery9 from './images/gallery9.jpg'

const imageList = [
  gallery1,
  gallery2,
  gallery3,
  gallery4,
  gallery5,
  gallery6,
  gallery7,
  gallery8,
  gallery9,
]
function App() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Carousel
        showArrows={true}
        showThumbs={true}
        autoPlay={true}
        infiniteLoop={true}
        interval={5000}
        showStatus={false}
        transitionTime={1000}
        swipeable={true}
        thumbWidth={50}
        renderThumbs={() =>
          imageList.map((e, idx) => (
            <img style={{ width: '50px' }} src={e} alt={`Gallery ${idx}`} />
          ))
        }
      >
        {imageList.map((e, idx) => {
          return (
            <div key={idx}>
              <img
                style={{ display: 'block', width: '100%', maxWidth: '500px' }}
                src={e}
                alt={`Gallery ${idx}`}
              />
            </div>
          )
        })}
      </Carousel>
    </div>
  )
}

export default App
